// extracted by mini-css-extract-plugin
export default {"placeholder":"FileUploadDragger_placeholder__9+EsU","spanText":"FileUploadDragger_spanText__sptm8"};